export const hasAllEqualDigits = (value) => {
  const digits = value.replace(/\D/g, "")
  return digits.length > 0 && /^(\d)\1+$/.test(digits)
}

export const isSequentialDigits = (value) => {
  const digits = value.replace(/\D/g, "").split("").map(Number)
  if (digits.length < 3) return false

  const expectedDiff = digits[1] - digits[0]
  if (Math.abs(expectedDiff) !== 1) return false

  for (let i = 2; i < digits.length; i++) {
    if (digits[i] - digits[i - 1] !== expectedDiff) return false
  }
  return true
}

export const validateCommonRules = (value) => {
  if (!value) return true

  if (isSequentialDigits(value)) return false

  if (hasAllEqualDigits(value)) return false

  return true
}
